/** @format */

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { geoLocationStateConstants } from '../../modules/getlocationstate/actions';

import { SimpleSelect } from './SimpleSelect';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { GeoLocationStateLoader } from '../../modules/getlocationstate/GeoLocationLoader';
import i18n from 'i18next';

type GeoLocationStateSelectProps = {
    dispatchName?: string;
    required: boolean;
    label: string;
    selectedValue?: number;
    callback?: (e: any) => void;
    loadedCallback?: () => void;
    nullFlag?: boolean;
};

const GeoLocationStateSelect = (props: GeoLocationStateSelectProps): React.ReactElement => {
    const dispatch = useDispatch();
    const [states, setStates] = useState<Array<HeaderCheckBoxSelectListElement>>([]);
    const loadedCallback = props.loadedCallback || null;
    const itemLoaders = useMemo(() => {
        return new ItemLoaders(dispatch);
    }, [dispatch]);
    const geoLocationStateLoader = useMemo(() => {
        return new GeoLocationStateLoader(itemLoaders);
    }, [itemLoaders]);

    const updateStates = useCallback((): void => {
        setStates(geoLocationStateLoader.getHeaderList());
    }, [geoLocationStateLoader]);

    useEffect(() => {
        geoLocationStateLoader.loadGeoLocationStates({
            filters: [],
            orders: [],
            callback: () => {
                updateStates();
                if (loadedCallback) {
                    loadedCallback();
                }
            },
        });
    }, [dispatch, updateStates, geoLocationStateLoader, loadedCallback]);

    if (states.length > 0) {
        let newElements = states;
        if (props.nullFlag) {
            newElements = [{ name: i18n.t('general:common.not_applicable'), value: -1 }, ...states];
        }
        return (
            <SimpleSelect
                dispatchName={props.dispatchName ?? geoLocationStateConstants.SELECT_CHANGE}
                label={props.label}
                required={props.required}
                callback={props.callback}
                elements={newElements}
                selectedValue={props.selectedValue}
                processValueForOutput={(value: number): string | null => {
                    return geoLocationStateLoader.getName(value);
                }}
            />
        );
    }

    return <></>;
};

export default GeoLocationStateSelect;
